// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RcDRs9qQqYoka1PA {
  max-width: 1315px;
  margin: 0 auto;
  padding-bottom: 96px;
}

.JQFNr2nfO3c9C0gJ {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.BBF2Uk2nNkwEsSWA {
  width: 300px;
  padding: 12px 10px;
  border-radius: 16px;
}

.Y45RwsiCdkUiWQTT {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.ulhTbWvVVcza2fVz {
  display: flex;
  align-items: center;
}

.I_KMVOg9BicXxGHZ {
  margin-right: 10px;
}

.RRsNgNubiqg90YTc {
  color: #000000;
  background-color: transparent;
  border: none;
  font-style: italic;
  cursor: pointer;
}

.RRsNgNubiqg90YTc i {
  font-size: 16px;
  background-color: #4d87be;
  color: #ffffff;
  padding: 10px;
  border-radius: 8px;
  margin-right: 12px;
}

.leZC90SN5IIhXR4d {
  color: #000000;
  background-color: transparent;
  border: none;
  cursor: pointer;
}

.leZC90SN5IIhXR4d i {
  font-size: 16px;
  background-color: #56be4d;
  color: #ffffff;
  padding: 10px;
  border-radius: 8px;
  margin-left: 12px;
}

.c0nh_l3MfIEGYbpo {
  border: 1px dashed #AA1919;
  border-radius: 8px;
  background-color: pink;
  color: #AA1919;
  padding: 10px 40px;
  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.FYA6W8TzDs80VQQx .fc-timegrid-slot {
  line-height: 12px;
  height: auto;
}

.FYA6W8TzDs80VQQx .fc-day-today {
  background-color: inherit !important;
}

.FYA6W8TzDs80VQQx .fc-col-header-cell-cushion {
  color: #303030;
}
.FYA6W8TzDs80VQQx .fc-timegrid-slot-label-cushion {
  color: #303030;
}

.FYA6W8TzDs80VQQx .fc-event {
  border-radius: 8px;
  padding-top: 8px;
}

.W2KH_loQREi3aqyN {
  display: none;
}

@media screen and (max-width: 790px) {
  .FYA6W8TzDs80VQQx {
    margin-top: 26px;
  }
  
  .W2KH_loQREi3aqyN {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: 26px;
    margin-bottom: 26px;
  }
  
  .YYcuqxaJ7EQk3MR_ {
    padding: 10px 12px;
    border: none;
    border-radius: 8px;
    background: transparent;
    cursor: pointer;
    text-align: center;
    color: #333;
    transition: background 0.2s ease;
    display: flex;
    flex-direction: column;
  }
  
  .YYcuqxaJ7EQk3MR_ span {
    font-size: 12px;
    font-weight: 300;
  }
  
  .YYcuqxaJ7EQk3MR_.ZkJC_81rvUo6Gt1_ {
    background-color: #fbe8c6;
  }
  
  .Y45RwsiCdkUiWQTT {
    display: grid;
    width: 100%;
    padding: 0 10%;
    grid-template-columns: 1fr 3fr;
    grid-template-areas: "delete create create create";
  }
  
  .MObukh2ouDULzNZD {
    grid-area: create;
    max-width: 296px;
    justify-items: end;
  }
  
  .kZF6N_DhccovL_oA {
    grid-area: delete;
  }
  
  .MObukh2ouDULzNZD span:first-child {
    font-size: 12px;
    font-weight: 300;
    font-style: italic;
    color: #7B7B7B;
  }
  
  .RRsNgNubiqg90YTc {
    width: 100%;
  }
  
  .RRsNgNubiqg90YTc i {
    width: 100%;
    color: #fff;
    background-color: #58A4A4;
    padding: 20px 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .RRsNgNubiqg90YTc span {
    display: none;
  }
  
  .c0nh_l3MfIEGYbpo {
    padding: 1.188rem 5px !important;
    margin-top: 20px;
    margin-left: 30px;
    grid-area: delete;
    max-width: 48px;
  }
  
  .c0nh_l3MfIEGYbpo i {
    margin-right: 0 !important;
  }
  
  .c0nh_l3MfIEGYbpo span {
    display: none;
  }
  
  .leZC90SN5IIhXR4d i {
    margin-right: 0 !important;
    padding: 1.25rem 20px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    margin-left: 30px;
    grid-area: delete;
    max-width: 48px;
  }
  
  .leZC90SN5IIhXR4d span {
    display: none;
  }
  
  .FYA6W8TzDs80VQQx {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
  }
  
  .FYA6W8TzDs80VQQx .fc {
    width: 70%;
  }
  
  .FYA6W8TzDs80VQQx .fc thead {
    display: none;
  }
  
  .FYA6W8TzDs80VQQx .fc-event {
    border-radius: 0 8px 8px 0;
    padding-left: 19px;
    width: 100%;
  }
  
  .FYA6W8TzDs80VQQx .fc-event.drag-resize {
    width: 40% !important;
    height: 40% !important;
  }
  
  .FYA6W8TzDs80VQQx .fc-event::before {
    content: '';
    margin-left: -25px;
    margin-top: -11px;
    width: 1px;
    padding: 4px;
    height: 100.7%;
    background-color: #306060;
    border-radius: 5px !important;
    display: block;
    position: absolute;
  }
  
  .FYA6W8TzDs80VQQx .fc-event.fc-event-selected::before {
    margin-left: 4px;
    margin-top: -3px;
  }
  
  .FYA6W8TzDs80VQQx .fc-col-header-cell-cushion {
    color: #899BAD;
  }
  .FYA6W8TzDs80VQQx .fc-timegrid-slot-label-cushion {
    color: #899BAD;
  }
  
  .FYA6W8TzDs80VQQx .fc table,
  .FYA6W8TzDs80VQQx .fc td,
  .FYA6W8TzDs80VQQx .fc th {
    border-style: none;
  }
  
  .FYA6W8TzDs80VQQx .fc .fc-timegrid-slot-label {
    border-right: #A4B7CA 1px solid !important;
    margin-right: 5px;
  }
  
  .FYA6W8TzDs80VQQx .fc .fc-timegrid-body {
    margin-top: 10px;
  }
}

@media screen and (max-width: 644px) {
   .MObukh2ouDULzNZD {
    margin: 0;
  }
}

@media screen and (max-width: 570px) {
  .c0nh_l3MfIEGYbpo {
    margin-left: -10px;
  }
  
  .kZF6N_DhccovL_oA {
    margin-left: -10px;
  }
  
  .FYA6W8TzDs80VQQx {
    display: block;
  }
  
  .FYA6W8TzDs80VQQx .fc {
    width: 100%;
  }

  .Y45RwsiCdkUiWQTT {
    width: 100%;
    padding: 0 3%;
    margin: 0;
  }
}

@media screen and (max-width: 520px) {
  .JQFNr2nfO3c9C0gJ {
    flex-direction: column;
    align-items: start;
  }
  
  .BBF2Uk2nNkwEsSWA {
    width: 100%;
    font-size: 14px !important;
    border-radius: 16px;
    padding: 4px 6px;
    height: 44px;
  }
  
  .BBF2Uk2nNkwEsSWA::placeholder {
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Manager/components/Scheduling.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,gCAAgC;IAChC,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,WAAW;IACX,cAAc;IACd,8BAA8B;IAC9B,kDAAkD;EACpD;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gCAAgC;IAChC,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;IACV,YAAY;IACZ,cAAc;IACd,yBAAyB;IACzB,6BAA6B;IAC7B,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;;EAEA;;;IAGE,kBAAkB;EACpB;;EAEA;IACE,0CAA0C;IAC1C,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;GACG;IACC,SAAS;EACX;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,aAAa;IACb,SAAS;EACX;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,0BAA0B;IAC1B,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".pageWrapper {\r\n  max-width: 1315px;\r\n  margin: 0 auto;\r\n  padding-bottom: 96px;\r\n}\r\n\r\n.pageHeader {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.dropdown {\r\n  width: 300px;\r\n  padding: 12px 10px;\r\n  border-radius: 16px;\r\n}\r\n\r\n.actions {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.left {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.toggleWrapper {\r\n  margin-right: 10px;\r\n}\r\n\r\n.dragCreateBtn {\r\n  color: #000000;\r\n  background-color: transparent;\r\n  border: none;\r\n  font-style: italic;\r\n  cursor: pointer;\r\n}\r\n\r\n.dragCreateBtn i {\r\n  font-size: 16px;\r\n  background-color: #4d87be;\r\n  color: #ffffff;\r\n  padding: 10px;\r\n  border-radius: 8px;\r\n  margin-right: 12px;\r\n}\r\n\r\n.saveBtn {\r\n  color: #000000;\r\n  background-color: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.saveBtn i {\r\n  font-size: 16px;\r\n  background-color: #56be4d;\r\n  color: #ffffff;\r\n  padding: 10px;\r\n  border-radius: 8px;\r\n  margin-left: 12px;\r\n}\r\n\r\n.deleteSlot {\r\n  border: 1px dashed #AA1919;\r\n  border-radius: 8px;\r\n  background-color: pink;\r\n  color: #AA1919;\r\n  padding: 10px 40px;\r\n  margin-left: 10px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.calendarWrapper :global(.fc-timegrid-slot) {\r\n  line-height: 12px;\r\n  height: auto;\r\n}\r\n\r\n.calendarWrapper :global(.fc-day-today) {\r\n  background-color: inherit !important;\r\n}\r\n\r\n.calendarWrapper :global(.fc-col-header-cell-cushion) {\r\n  color: #303030;\r\n}\r\n.calendarWrapper :global(.fc-timegrid-slot-label-cushion) {\r\n  color: #303030;\r\n}\r\n\r\n.calendarWrapper :global(.fc-event) {\r\n  border-radius: 8px;\r\n  padding-top: 8px;\r\n}\r\n\r\n.weekdaySwitcher {\r\n  display: none;\r\n}\r\n\r\n@media screen and (max-width: 790px) {\r\n  .calendarWrapper {\r\n    margin-top: 26px;\r\n  }\r\n  \r\n  .weekdaySwitcher {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 8px;\r\n    margin-top: 26px;\r\n    margin-bottom: 26px;\r\n  }\r\n  \r\n  .weekdayBtn {\r\n    padding: 10px 12px;\r\n    border: none;\r\n    border-radius: 8px;\r\n    background: transparent;\r\n    cursor: pointer;\r\n    text-align: center;\r\n    color: #333;\r\n    transition: background 0.2s ease;\r\n    display: flex;\r\n    flex-direction: column;\r\n  }\r\n  \r\n  .weekdayBtn span {\r\n    font-size: 12px;\r\n    font-weight: 300;\r\n  }\r\n  \r\n  .weekdayBtn.selected {\r\n    background-color: #fbe8c6;\r\n  }\r\n  \r\n  .actions {\r\n    display: grid;\r\n    width: 100%;\r\n    padding: 0 10%;\r\n    grid-template-columns: 1fr 3fr;\r\n    grid-template-areas: \"delete create create create\";\r\n  }\r\n  \r\n  .createSlot {\r\n    grid-area: create;\r\n    max-width: 296px;\r\n    justify-items: end;\r\n  }\r\n  \r\n  .saveBtnWrapper {\r\n    grid-area: delete;\r\n  }\r\n  \r\n  .createSlot span:first-child {\r\n    font-size: 12px;\r\n    font-weight: 300;\r\n    font-style: italic;\r\n    color: #7B7B7B;\r\n  }\r\n  \r\n  .dragCreateBtn {\r\n    width: 100%;\r\n  }\r\n  \r\n  .dragCreateBtn i {\r\n    width: 100%;\r\n    color: #fff;\r\n    background-color: #58A4A4;\r\n    padding: 20px 10px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n  \r\n  .dragCreateBtn span {\r\n    display: none;\r\n  }\r\n  \r\n  .deleteSlot {\r\n    padding: 1.188rem 5px !important;\r\n    margin-top: 20px;\r\n    margin-left: 30px;\r\n    grid-area: delete;\r\n    max-width: 48px;\r\n  }\r\n  \r\n  .deleteSlot i {\r\n    margin-right: 0 !important;\r\n  }\r\n  \r\n  .deleteSlot span {\r\n    display: none;\r\n  }\r\n  \r\n  .saveBtn i {\r\n    margin-right: 0 !important;\r\n    padding: 1.25rem 20px !important;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin-top: 20px;\r\n    margin-left: 30px;\r\n    grid-area: delete;\r\n    max-width: 48px;\r\n  }\r\n  \r\n  .saveBtn span {\r\n    display: none;\r\n  }\r\n  \r\n  .calendarWrapper {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 20px;\r\n  }\r\n  \r\n  .calendarWrapper :global(.fc) {\r\n    width: 70%;\r\n  }\r\n  \r\n  .calendarWrapper :global(.fc thead) {\r\n    display: none;\r\n  }\r\n  \r\n  .calendarWrapper :global(.fc-event) {\r\n    border-radius: 0 8px 8px 0;\r\n    padding-left: 19px;\r\n    width: 100%;\r\n  }\r\n  \r\n  .calendarWrapper :global(.fc-event.drag-resize) {\r\n    width: 40% !important;\r\n    height: 40% !important;\r\n  }\r\n  \r\n  .calendarWrapper :global(.fc-event::before) {\r\n    content: '';\r\n    margin-left: -25px;\r\n    margin-top: -11px;\r\n    width: 1px;\r\n    padding: 4px;\r\n    height: 100.7%;\r\n    background-color: #306060;\r\n    border-radius: 5px !important;\r\n    display: block;\r\n    position: absolute;\r\n  }\r\n  \r\n  .calendarWrapper :global(.fc-event.fc-event-selected::before) {\r\n    margin-left: 4px;\r\n    margin-top: -3px;\r\n  }\r\n  \r\n  .calendarWrapper :global(.fc-col-header-cell-cushion) {\r\n    color: #899BAD;\r\n  }\r\n  .calendarWrapper :global(.fc-timegrid-slot-label-cushion) {\r\n    color: #899BAD;\r\n  }\r\n  \r\n  .calendarWrapper :global(.fc table),\r\n  .calendarWrapper :global(.fc td),\r\n  .calendarWrapper :global(.fc th) {\r\n    border-style: none;\r\n  }\r\n  \r\n  .calendarWrapper :global(.fc .fc-timegrid-slot-label) {\r\n    border-right: #A4B7CA 1px solid !important;\r\n    margin-right: 5px;\r\n  }\r\n  \r\n  .calendarWrapper :global(.fc .fc-timegrid-body) {\r\n    margin-top: 10px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 644px) {\r\n   .createSlot {\r\n    margin: 0;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 570px) {\r\n  .deleteSlot {\r\n    margin-left: -10px;\r\n  }\r\n  \r\n  .saveBtnWrapper {\r\n    margin-left: -10px;\r\n  }\r\n  \r\n  .calendarWrapper {\r\n    display: block;\r\n  }\r\n  \r\n  .calendarWrapper :global(.fc) {\r\n    width: 100%;\r\n  }\r\n\r\n  .actions {\r\n    width: 100%;\r\n    padding: 0 3%;\r\n    margin: 0;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 520px) {\r\n  .pageHeader {\r\n    flex-direction: column;\r\n    align-items: start;\r\n  }\r\n  \r\n  .dropdown {\r\n    width: 100%;\r\n    font-size: 14px !important;\r\n    border-radius: 16px;\r\n    padding: 4px 6px;\r\n    height: 44px;\r\n  }\r\n  \r\n  .dropdown::placeholder {\r\n    font-size: 14px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
export var pageWrapper = `RcDRs9qQqYoka1PA`;
export var pageHeader = `JQFNr2nfO3c9C0gJ`;
export var dropdown = `BBF2Uk2nNkwEsSWA`;
export var actions = `Y45RwsiCdkUiWQTT`;
export var left = `ulhTbWvVVcza2fVz`;
export var toggleWrapper = `I_KMVOg9BicXxGHZ`;
export var dragCreateBtn = `RRsNgNubiqg90YTc`;
export var saveBtn = `leZC90SN5IIhXR4d`;
export var deleteSlot = `c0nh_l3MfIEGYbpo`;
export var calendarWrapper = `FYA6W8TzDs80VQQx`;
export var weekdaySwitcher = `W2KH_loQREi3aqyN`;
export var weekdayBtn = `YYcuqxaJ7EQk3MR_`;
export var selected = `ZkJC_81rvUo6Gt1_`;
export var createSlot = `MObukh2ouDULzNZD`;
export var saveBtnWrapper = `kZF6N_DhccovL_oA`;
export default ___CSS_LOADER_EXPORT___;
